var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1373 3.09767C11.3941 3.30435 12.4717 4.32651 13.1869 5.20436C13.6585 5.7832 13.2307 6.55909 12.4845 6.53383C10.5975 6.46995 7.65408 6.19059 6.92199 5.09117C5.822 3.43926 7.85274 2.72198 10.1373 3.09767Z",
    stroke: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.557 3.09767C17.3002 3.30435 16.2226 4.32651 15.5074 5.20436C15.0359 5.7832 15.4636 6.55909 16.2098 6.53383C18.0968 6.46995 21.0403 6.19059 21.7723 5.09117C22.8723 3.43926 20.8416 2.72198 18.557 3.09767Z",
    stroke: "#808080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 8.17383,
    width: 9.83334,
    height: 3.43896,
    rx: 0.5,
    stroke: "#808080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16602,
    y: 11.6992,
    width: 8.1667,
    height: 11.4548,
    rx: 0.5,
    stroke: "#808080"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 8.17383,
    width: 9.00001,
    height: 3.43896,
    rx: 0.5,
    stroke: "#808080"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.16602,
    y: 11.6992,
    width: 15.6667,
    height: 11.4548,
    rx: 0.5,
    stroke: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.8e324e43102ea3376ad3b36d8e55799d.svg";
export { ForwardRef as ReactComponent };